// @flow
import React from 'react';
import styled from 'styled-components';

import colors from '../../assets/css/colors';

const Wrapper = styled.div`
	height: 3.57em;
	font-size: 12px;
	line-height: 3.57;
	text-align: center;
	border-radius: 5px;
	font-weight: bold;
	color: ${colors.title};
	box-shadow: 0 0 20px 5px rgba(0,0,0,0.15);
	background: #fff;
	padding: 0 1.2em;
	box-sizing: border-box;
	min-width: 11.4em;
	white-space: nowrap;

	position: absolute;
	bottom: calc(100% + 6px);
	left: 50%;
	transform: translateX(-50%);

	opacity: 0;
	visibility: hidden;
	transition: opacity 0.2s linear;
	display: none;

	*:hover > & {
		opacity: 1;
		visibility: visible;
		display: block;
	}

	&:after {
		content: '';
		display: block;
		width: 0;
		height: 0;
		border-style: solid;
		border-width: 10px 5px 0 5px;
		border-color: #ffffff transparent transparent transparent;
		position: absolute;
		top: calc(100% - 2px);
		left: 50%;
		transform: translateX(-50%);
	}
`;

type Props = {
	text: string
}

export const ThToolTip = ({ text }: Props) => (
	<Wrapper>
		{text}
	</Wrapper>
);

export default ThToolTip;


// WEBPACK FOOTER //
// ./src/components/ThToolTip/index.js